import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { DtoBase } from "../DtoBase";
import { NetViewDto } from "./NetViewDto";
import { AgentDto } from "../Agents/AgentDto";

export class NetViewTreeDto extends DtoBase {

	public NetViews: List<NetViewDto>;
	public Agents: List<AgentDto>;

	constructor() {
		super();

		this.NetViews = new List<NetViewDto>();
		this.Agents = new List<AgentDto>();
	}

	public get HasNetViews(): boolean {
		return (this.NetViews && this.NetViews.Count > 0);
	}

	public get HasAgents(): boolean {
		return (this.Agents && this.Agents.Count > 0);
	}

	public AddNetView(value: NetViewDto): void {
		this.NetViews.Add(value);
	}

	public AddAgent(value: AgentDto): void {
		this.Agents.Add(value);
	}

	public FindNetViewByGuid(guid: string): NetViewDto {
		for (let i: number = 0; i < this.NetViews.Count; ++i) {
			if (this.NetViews.Get(i).Guid === guid)
				return this.NetViews.Get(i);
		}
		return null;
	}

	public FindAgentByGuid(guid: string): AgentDto {
		for (let i: number = 0; i < this.Agents.Count; ++i) {
			if (this.Agents.Get(i).Guid === guid)
				return this.Agents.Get(i);
		}
		return null;
	}

	public RootForUser(userGuid: string): NetViewDto {
		for (let i: number = 0; i < this.NetViews.Count; ++i) {
			let netView: NetViewDto = this.NetViews.Get(i);
			if (!netView.Name && (netView.UserGuid === userGuid))
				return netView;
		}
		return new NetViewDto();
	}

	public Write(obj: any, context: any): void {
		obj.net_view_tree = {};
		obj = obj.net_view_tree;

		super.Write(obj, context);

		if (this.HasNetViews) {
			obj.net_views = [];
			ObjSerUtils.WriteObjSerCollection(obj.net_views, this.NetViews, context);
		}

		if (this.HasAgents) {
			obj.agents = [];
			ObjSerUtils.WriteObjSerCollection(obj.agents, this.Agents, context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.net_view_tree)
			throw new Error();
		obj = obj.net_view_tree;

		super.Read(obj, context);

		if (obj.net_views !== undefined) {
			ObjSerUtils.ReadObjSerCollection(obj.net_views, this.NetViews,
				(value: any) => new NetViewDto(), context);
		}

		if (obj.agents !== undefined) {
			ObjSerUtils.ReadObjSerCollection(obj.agents, this.Agents,
				(value: any) => new AgentDto(), context);
		}
	}

}
